






































































































































































import { Component, Vue } from "vue-property-decorator";

import SettingsItemGroup from "@/components/SettingsItemGroup.vue";
import SettingsRange from "@/components/SettingsRange.vue";
import { ILottoTicket } from "@/interface";
import { MTGSetType } from "@/enum";
import { Lotto } from "@/lotto";

@Component({
    name: "SettingsBubble",
    props: ["visible"],
    components: {
        SettingsItemGroup,
        SettingsRange,
    },
})
export default class SettingsBubble extends Vue {

    private lottoSets: ILottoTicket[] = [];

    private lastType: MTGSetType = MTGSetType.Expansion;
    private Types = MTGSetType;

    public async beforeMount() {
        const lotto = (await this.$root.$data.lottery) as Lotto;
        const lottoSets: ILottoTicket[] = Array.from(lotto.sets);

        this.lottoSets = lottoSets;
    }

    public toggleTicket(setCode: string, newStatus?: boolean): void {
        const foundTicket = this.lottoSets.find((ticket) => ticket.set.code === setCode);

        if (foundTicket && typeof newStatus !== "undefined") {
            foundTicket.enabled = newStatus;
        } else if (foundTicket) {
            foundTicket.enabled = !foundTicket.enabled;
        }
    }

    public getTicketsOfType(setType: MTGSetType): ILottoTicket[] {
        return this.lottoSets.filter((ticket) => ticket.set.type === setType);
    }

    public newLotteryTime(newTime: number): void {
        this.$root.$data.lotteryTime = newTime;
    }

    public newSetsToGenerate(newSetCount: number): void {
        this.$root.$data.setsToGenerate = newSetCount;
    }

    public newFrameRate(newFrameRate: number): void {
        this.$root.$data.frameRate = newFrameRate;
    }
}
